import { SalesOrderDeliveryStatusEnum, SalesOrderInvoiceStatusEnum, SalesOrderStatusEnum } from "./sales-order-status-enum";

export const salesOrderStatusColors = {
  [SalesOrderStatusEnum.PAID]: "success",
  [SalesOrderStatusEnum.VOID]: "error",
};

export const salesOrderDeliveryStatusColors = {
  [SalesOrderDeliveryStatusEnum.PENDING]: "default",
  [SalesOrderDeliveryStatusEnum.PARTIALLY_DELIVERED]: "warning",
  [SalesOrderDeliveryStatusEnum.FULLY_DELIVERED]: "success",
};

export const salesOrderInvoiceStatusColors = {
  [SalesOrderInvoiceStatusEnum.PENDING]: "default",
  [SalesOrderInvoiceStatusEnum.PARTIALLY_INVOICED]: "warning",
  [SalesOrderInvoiceStatusEnum.FULLY_INVOICED]: "success",
};
